// Leadership / team shown on the About page. Kept deliberately short — the
// company's certifications live in the Credentials section, not here.
// Drop a photo at public/team/yahya.jpg and set `photo` to '/team/yahya.jpg'
// to replace the initial avatar.

import { SITE } from './site';

export interface TeamMember {
  name: string;
  role: string;
  summary: string;
  email: string;
  photo?: string;
}

export const TEAM: TeamMember[] = [
  {
    name: SITE.contact.name,
    role: SITE.contact.role,
    summary:
      'You work directly with the person building your solution — no handoffs between sales and delivery, no offshore team you’ve never met.',
    email: SITE.contact.email,
  },
];
